import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["label", "icon"];
  static values = { collapsed: String, expanded: String };

  toggle() {
    const label = this.labelTarget;
    const isExpanded = label.textContent === this.expandedValue;
    label.textContent = isExpanded ? this.collapsedValue : this.expandedValue;
    this.iconTarget.classList.toggle("rotate-180", isExpanded);
  }
}
